import { AnyAction } from 'redux';

import * as constants from 'redux/constants/cementeries.constants';
import { ITableUpdate } from 'types/table.types';
import { ICementeriesFormData } from 'views/CementeriesView/components/CementeriesForm/types';

export const onDelete = (id: string): AnyAction => ({
  type: constants.CEMENTERIES_ON_DELETE_REQUESTED,
  id,
});

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.CEMENTERIES_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onGetOne = (id: string): AnyAction => ({
  type: constants.CEMENTERIES_ON_GET_ONE_REQUESTED,
  id,
});

export const onSave = (formData: ICementeriesFormData, id?: string): AnyAction => ({
  type: constants.CEMENTERIES_ON_SAVE_REQUESTED,
  formData,
  id,
});
